import { render, staticRenderFns } from "./_DossiersInstruits.vue?vue&type=template&id=50f59d32&"
import script from "./_DossiersInstruits.vue?vue&type=script&lang=ts&"
export * from "./_DossiersInstruits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports